
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcNotificationBadgeButton as ObcNotificationBadgeButtonElement} from '@oicl/openbridge-webcomponents/dist/components/notification-badge-button/notification-badge-button.js';
 
 
 

 
 export const ObcNotificationBadgeButton = createComponent({
   react: React,
   tagName: 'obc-notification-badge-button',
   elementClass: ObcNotificationBadgeButtonElement,
   events: {
     
   }
  });
 
 